import { Item as RadixItem } from '@radix-ui/react-context-menu';
import type React from 'react';
import { forwardRef } from 'react';
import { itemClassNames } from '../common';

interface ItemProps {
  children: React.ReactNode;
  onClick?: () => void;
  className?: string;
  'data-testid'?: string;
}

/**
 *  Item to display when the ContextMenu is activated
 *  ```tsx
 *  import Item from '~/components2/ContextMenu/Item'
 *
 *  <Item onClick={() => fooBar()}>Some Item</Item>
 *  ```
 *  @param {children} props.children - Label/text to display for the item.
 *  @param {onClick} props.onClick - (optional) callback function to execute upon a user click.
 *  @param {className} props.className - (optional) additional classNames to be added to the component styling.
 *  @returns
 */

const Item = forwardRef<HTMLDivElement, ItemProps>(({ children, onClick, className, ...rest }, ref) => {
  return (
    <RadixItem ref={ref} onClick={onClick} className={`${itemClassNames} ${className}`} {...rest}>
      {children}
    </RadixItem>
  );
});

Item.displayName = 'Item';
export default Item;
